module.exports = __webpack_public_path__ + "fonts/checkbox-01@2x.d5554fe41aed23e1e49f249f2f6bcfaa.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/forms/checkbox-01@2x.png
// module id = 819
// module chunks = 9